import React, { Component } from "react";
import { Link } from "react-router-dom";
import { checkZone,seperator } from "../../resources/animationfunction";
import 'react-input-range/lib/css/index.css';
import { Range, getTrackBackground } from "react-range";
import ScrollToButton from '../../components/buttons/ScrollToButton';

const STEP1 = 1000;
const MIN1 = 1000;
const MAX1 = 99999999;
class WebTalkAddReward extends Component{

	constructor(props){
		super(props);
		this.state={
			regionData:null,
			region:[],
			fillOptions:'',
			fillRegionalOptions:'',
			openSelectRegion:false,
			openSelectCategory:false,
		 	value: [1000],
		 	setValueRegion:'',
		 	setValueCategory:'',
		 	estimatedValue:0,
		 	getCalculatedValue:null,
		 	showMonthlycontent:false,
		 	showRegionContent:window.innerWidth>=767 ? false : true,
		}
	 window.addEventListener('resize',()=>{
	 if(document.getElementsByClassName("parent-dropdown-selected")){
	 	if(window.innerWidth>767 && document.querySelector(".parent-dropdown-selected").classList.contains("has-selected-value")){
	 		this.setState({showRegionContent:false})
	 	}
	 	else if(window.innerWidth>767 && !document.querySelector(".parent-dropdown-selected").classList.contains("has-selected-value")){
	 		this.setState({showRegionContent:false})
	 	}else if(window.innerWidth<=767 && !document.querySelector(".parent-dropdown-selected").classList.contains("has-selected-value"))	{
	 			this.setState({showRegionContent:true})
	 	}else if(window.innerWidth<=767 && document.querySelector(".parent-dropdown-selected").classList.contains("has-selected-value")){
 			this.setState({showRegionContent:false})
	 	}
	 }
	 });
	 this.categoryRef=React.createRef();
	}

	componentDidMount() {
		const continents = ["Asia & Pacific", "Europe, Middle East and Africa", "North America", "South America"];
		this.setState({ regionData: continents })
		let regionOption;
		continents.map((key) => {
			this.state.region.push(`${key}`)
			regionOption = this.state.region.map((item, index) => {
				return (
					<li key={index}><Link rel={item} key={index} className="region-select" onClick={(e) => this.changeZone(e)}>{item}</Link></li>
				)
			})
		});
		this.setState({ fillOptions: regionOption })
	}

	changeZone=(e)=>{
		document.querySelectorAll(".region-select").forEach((item)=>{
			item.classList.remove("active")
		});
		e.target.classList.add("active");
		e.target.parentNode.parentNode.classList.add("has-selected-value");
		this.setState({setValueRegion:e.target.rel})
		let RegionalAreas=["High","Avg","Low"];
		let RegionalOptions = RegionalAreas.map((regionItems,index)=>{
			return(
					<li  key={index}><Link rel={regionItems} className="category-select"  key={index} onClick={(e)=>this.changeCategory(e)}>{regionItems}</Link></li>
			)
		})

		this.setState({showRegionContent:false,fillRegionalOptions:RegionalOptions,openSelectRegion:false,estimatedValue : document.querySelector(".category-select.active")!==null ? checkZone(e.target,document.querySelector(".category-select.active").textContent).estimatedValue : 0});		
			this.CalculateSense(this.state.value,document.querySelector(".category-select.active")!==null ?checkZone(e.target,document.querySelector(".category-select.active").textContent).estimatedValue : 0);
	}	

	changeCategory=(e)=>{

		document.querySelectorAll(".category-select").forEach((item,index)=>{
			item.classList.remove("active");
		});
		e.target.classList.add("active");
		this.setState({showMonthlycontent:true,openSelectCategory:false,setValueCategory: e.target.rel, estimatedValue :checkZone(document.querySelector(".region-select.active"),e.target.textContent).estimatedValue});
		this.CalculateSense(this.state.value,checkZone(document.querySelector(".region-select.active"),e.target.textContent).estimatedValue);
		
	}

	CalculateSense=(value,getEstimatedValue)=>{
		if(getEstimatedValue > 0 ){
			this.setState({value:value,getCalculatedValue : Math.round(Number(getEstimatedValue/1000 * value))})
		}

		
	}

	/*showAlertify=()=>{
		if(!document.querySelector(".region-select").classList.contains("active") || this.state.fillRegionalOptions===''){
			this.displayMsg();
		}
	}

*/
	render() {
		return (
			<section className="webtalk-ad-rewards">
				{/*<ToastContainer autoClose={2000} limit={1}/>*/}
				  <div className="webtalk-ad-rewards-container animate-fade">
				    <span>earn</span>

				    <h2>See how much you could earn from Webtalk Ad Rewards</h2>
				    <p>Your Webtalk follower’s location and advertising value is set as</p>


				    <div className="select-location-value flex">
				      <div className={this.state.openSelectRegion ? "selectox active-region" : "selectox"}>

				      	<Link className="selectBox custom-select selectBox-dropdown" onClick={(e)=>{
				      		this.state.openSelectRegion ? this.setState({openSelectRegion:false}) : this.setState({openSelectRegion:true})
				      	}}>
					      	<span className="selectBox-label">{this.state.setValueRegion!=='' ? this.state.setValueRegion : "Select a location"}</span>
					      	<span className="selectBox-arrow"></span>
				      	</Link>

				      	<ul className="selectBox-dropdown-menu parent-dropdown-selected selectBox-options custom-select-selectBox-dropdown-menu ">
						<li><Link rel="" className="region-select">Select a location</Link></li>
				      	{this.state.fillOptions}
				      	</ul>
				      </div>
				      {!this.state.showRegionContent &&
				        <div className={this.state.openSelectCategory ? "selectox active-category" : "selectox"}>

				      	<Link className="selectBox custom-select selectBox-dropdown" onClick={(e)=>{
				      		this.state.openSelectCategory ? this.setState({openSelectCategory:false}) : this.setState({openSelectCategory:true})
				      	}}>
					      	<span className="selectBox-label">{this.state.setValueCategory!=='' ? this.state.setValueCategory : "Select an ad value"}</span>
					      	<span className="selectBox-arrow"></span>
				      	</Link>
				      	 
				      	<ul className="selectBox-dropdown-menu selectBox-options custom-select-selectBox-dropdown-menu regio-select-box">
						<li><Link rel="" className="category-select">Select an ad value</Link></li>
				      	{this.state.fillRegionalOptions}
				      	</ul>
				      </div>
				      }
				    </div>
				    {this.state.showMonthlycontent && 
				    <div className="monthly-content-views flex">
				      <p>your monthly content views</p>
				      <div className="range-slider">
				        <div>
				           <div style={{display: "flex",justifyContent: "center",flexWrap: "wrap"}}>
                         	 <Range
                              values={this.state.value}
                              step={STEP1}
                              min={MIN1}
                              max={MAX1}
                              onChange={(value) =>{this.setState({ value }); this.CalculateSense(value,this.state.estimatedValue)}}
                              renderTrack={({ props, children }) => (
                                                                <div onMouseDown={props.onMouseDown} onTouchStart={props.onTouchStart} style={{...props.style,height: "36px",display: "flex",width: "100%"}}>
                                                                      
                                                                      <div ref={props.ref} style={{height: "4px",width: "100%",borderRadius: "4px",
                                                                         background: getTrackBackground({
                                                                                values: this.state.value,
                                                                                colors: ["#006AFF", "#E3EFFF"],
                                                                                min: MIN1,
                                                                                max: MAX1
                                                                          }),alignSelf: "center"}}>  {children}
                                                                      </div>
                                                                </div>)}
                              renderThumb={({ props, isDragged }) => (
                                                                    <div className="input-range__slider" {...props} >
                                                                        
                                                                          <div style={{height: "0",width: "0",backgroundColor: isDragged ? "#548BF4" : "#CCC"}}/>
                                                                    </div>
                                                                  )}/>
                              <output className="output"  id="output">{seperator(this.state.value[0])}</output>
                      	</div>
				        </div>
				      </div>    
				    </div>}

				    <div className="your-annual-rewards" style={{backgroundImage: `url(images/your-annual-rewards.png)`}}>
				      <span>Your Annual Ad Rewards</span>
				      <p>This is an estimate and should only be used as a reference</p>
				      <h3>${this.state.getCalculatedValue !== null ? seperator(this.state.getCalculatedValue) : seperator(this.state.estimatedValue)} <sup>*</sup></h3>
				      <ScrollToButton/>
				    </div>

				    <p>* Individual result will vary. There's no guarantee or commitment that you'll earn this amount. Advertising estimates are based on the content category, ad viewer demographic, and geography. Actual revenue is dependent on many factors such as advertiser demand, user location, user device, content vertical, seasonality, ad size, and currency exchange rates. </p>
				  </div>
			</section>
		);
	}

};

export default WebTalkAddReward;